<template>
	<el-dialog title="运单详情" v-model="isDetail" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="page_warp scroll-view">
			<div class="nav_warp">
				<div class="nav_item" :class="index == 0 ? 'nav_item_ac' : ''" @click="navClick(0)">
					<p>装货数据<span v-if="loadChkCount!=0">{{loadChkCount}}</span></p>
					<div v-if="index == 0" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="index == 1 ? 'nav_item_ac' : ''" @click="navClick(1)">
					<p>卸货数据<span v-if="unloadChkCount!=0">{{unloadChkCount}}</span></p>
					<div v-if="index == 1" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="index == 3 ? 'nav_item_ac' : ''" @click="navClick(3)">
					<p>车辆在途数据</p>
					<div v-if="index ==3" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="index == 2 ? 'nav_item_ac' : ''" @click="navClick(2)">
					<p>费用数据<span v-if="expensesChkCount!=0">{{expensesChkCount}}</span></p>
					<div v-if="index == 2" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="index == 4 ? 'nav_item_ac' : ''" @click="navClick(4)"
					v-if="permissionItem.fee">
					<p>运费收入<span v-if="lorFreightChkStatus==0">{{1}}</span></p>
					<div v-if="index == 4" class="nav_item_line"></div>
				</div>
			</div>

			<!-- 装货项目 -->
			<div class="custUpWarp" style="max-height: 500px; overflow: auto" v-show="index == 0">
				<div class="flex">
					<div class="rpt_tit">
						<p class="platTitle">计划装货数据</p>
					</div>
					<!-- <div class="editimg fontSize18">
						<div v-if="vehedit" class="flex">
							<div class="mr-10" @click="veheditsave">保存</div>
							<div @click="veheditChange(false)">取消</div>
						</div>
						<div @click="veheditChange(true)" v-else>编辑</div>
					</div> -->
				</div>
				<div class="info-input-container">
					<div class="flex flex-y-center flex-wrap">
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>托运商</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-select v-model="lorShipper" placeholder="请选择所属客商" disabled>
									<el-option v-for="item in ProviderTYList" :key="item.cocId" :label="item.cocName"
										:value="item.cocId" />
								</el-select>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>贸易商:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-select v-model="lorSupplier" placeholder="请选择所属客商" disabled>
									<el-option v-for="item in ProviderMYList" :key="item.cocId" :label="item.cocName"
										:value="item.cocId" />
								</el-select>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>货品</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-select v-model="lorGoods" placeholder="请选择货品" disabled>
									<el-option label="LNG" :value="1" />
									<el-option label="CNG" :value="2" />
								</el-select>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>计划装货时间</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="lorLoadpTime" type="datetime" :clearable="false"
									placeholder="请选择计划装货时间" @change="getlorLoadpTime" style="width: 100%;" disabled>
								</el-date-picker>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>计划装货吨位（吨）:</span>
							</div>
							<el-input v-model="lorLoadpWeight" class="platItemRigth" placeholder="请输入" type="number"
								disabled />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>装货站点:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-select v-model="lorLoadWhid" placeholder="请选择" @change="siteLoadChange" disabled>
									<el-option v-for="(item, index) in loadsiteList" :key="index" :label="item.whName"
										:value="item.whId">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>装货地地址:</span>
							</div>
							<el-input v-model="lorLoadAddr" class="platItemRigth" disabled />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>备注:</span>
							</div>
							<el-input v-model="lorRemark" class="platItemRigth" placeholder="请输入" disabled />
						</div>
					</div>
				</div>

				<div class="flex">
					<div class="rpt_tit">
						<p class="platTitle">实际装货数据
							<span class="auditwait" v-if="lorChkStatus=='0'">待审核</span>
							<span class="auditpass" v-else-if="lorChkStatus=='1'">审核通过</span>
							<span class="auditnopass" v-else-if="lorChkStatus=='2'">审核不通过</span>
							<span class="auditpass" v-else>未提交</span>
						</p>
					</div>
					<div class="editimg fontSize18" style="text-decoration: underline;" v-if="permissionItem.audit">
						<div v-if="loadedit" class="flex">
							<div class="mr-10" @click="loadeditsave">保存</div>
							<div class="mr-10" @click="loadeditChange(false)">取消</div>
						</div>
						<div class="mr-10" @click="loadeditChange(true)" v-if="lorChkStatus=='0'&&!loadedit">编辑
						</div>
						<div v-if="lorChkStatus=='0'" @click="handleAudits('load',lorId)">审核
						</div>
					</div>
				</div>
				<div class="info-input-container">
					<div class="flex flex-y-center flex-wrap">
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>实际装货到站时间</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="lorLoadsTime" type="datetime" :clearable="false"
									placeholder="请选择计划装货时间" @change="getlorLoadpTime" style="width: 100%;"
									:readonly="loadeditisReadOnly">
								</el-date-picker>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>装货开始时间:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="lorLoadStartTime" type="datetime" :clearable="false"
									placeholder="请选择计划装货时间" @change="getlorLoadpTime" style="width: 100%;"
									:readonly="loadeditisReadOnly">
								</el-date-picker>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>装货离站时间:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="lorLoadOffsiteTime" type="datetime" :clearable="false"
									placeholder="请选择计划装货时间" @change="getlorLoadpTime" style="width: 100%;"
									:readonly="loadeditisReadOnly">
								</el-date-picker>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>实际装货吨位（吨）:</span>
							</div>
							<el-input v-model="lorLoadsWeight" class="platItemRigth" placeholder="请输入" type="number"
								:readonly="loadeditisReadOnly" />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>空车里程（KM）:</span>
							</div>
							<el-input v-model="lorLoadEmpMilage" class="platItemRigth" placeholder="请输入" type="number"
								readonly />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>装货磅单编号:</span>
							</div>
							<el-input v-model="lorLoadPound" class="platItemRigth" placeholder="请输入"
								:readonly="loadeditisReadOnly" />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>表显里程（装货）:</span>
							</div>
							<el-input v-model="lorLoadOdometer" class="platItemRigth" placeholder="请输入" type="number"
								:readonly="loadeditisReadOnly" />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>备注:</span>
							</div>
							<el-input v-model="lorSubmitRemark" class="platItemRigth" placeholder="请输入"
								:readonly="loadeditisReadOnly" />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>表显里程照片:</span>
							</div>
							<div class="upRpic_icon_item2" v-if="lorLoadOdoUrl == ''||lorLoadOdoUrl == null">
								<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
							</div>
							<div class="upRpic_icon_item2" v-viewer v-else>
								<img class="upRpic2_icon" :src="lorLoadOdoUrl" />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>装货磅单照片:</span>
							</div>
							<div class="upRpic_icon_item2" v-if="lorLoadPouUrl == ''||lorLoadPouUrl == null">
								<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
							</div>
							<div class="upRpic_icon_item2" v-viewer v-else>
								<img class="upRpic2_icon" :src="lorLoadPouUrl" />
							</div>
						</div>
					</div>
				</div>

			</div>

			<!-- 卸货项目 -->
			<div v-show="index==1" class="custUpWarp" style="max-height: 500px; overflow: auto">
				<div class="flex">
					<div class="rpt_tit">
						<p class="platTitle">计划卸货数据</p>
					</div>
					<div class="editimg fontSize18" style="text-decoration: underline;" v-if="permissionItem.edit">
						<div v-if="planUnloadedit" class="flex">
							<div class="mr-10" @click="planUnloadeditsave">保存</div>
							<div class="mr-10" @click="planUnloadeditChange(false)">取消</div>
						</div>
						<div @click="planUnloadeditChange(true)"
							v-if="unloadList[0].lorlChkStatus!=='1'&&!planUnloadedit">编辑</div>
					</div>
				</div>
				<div class="info-input-container">
					<div class="flex flex-y-center flex-wrap">
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>卸货站点:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-select v-model="unloadList[0].lorlEndWhid" placeholder="请选择"
									@change="siteUnloadChange(0,unloadList[0].lorlEndWhid)"
									:disabled="planUnloadeditisReadOnly">
									<el-option v-for="(item, index) in unloadsiteList" :key="index" :label="item.whName"
										:value="item.whId">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>卸货地地址:</span>
							</div>
							<el-input v-model="unloadList[0].lorlEndAddr" class="platItemRigth" disabled />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>计划到站时间</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="unloadList[0].lorlUnlpTime" type="datetime" :clearable="false"
									placeholder="请选择计划到站时间" @change="getlorlUnlpTime(0,unloadList[0].lorlUnlpTime)"
									style="width: 100%;" :disabled="planUnloadeditisReadOnly">
								</el-date-picker>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>计划卸货吨位（吨）:</span>
							</div>
							<el-input v-model="unloadList[0].lorlUnlpWeight" class="platItemRigth" placeholder="请输入"
								type="number" :disabled="planUnloadeditisReadOnly" />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>收货人:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-input v-model="unloadList[0].lorlEndContact" placeholder="请输入"
									:disabled="planUnloadeditisReadOnly" />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>收货人电话:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-input v-model="unloadList[0].lorlEndPhone" placeholder="请输入"
									:disabled="planUnloadeditisReadOnly" />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>备用联系人:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-input v-model="unloadList[0].lorlEndContact2" placeholder="请输入"
									:disabled="planUnloadeditisReadOnly" />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>备用联系电话:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-input v-model="unloadList[0].lorlEndPhone2" placeholder="请输入"
									:disabled="planUnloadeditisReadOnly" />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>备注:</span>
							</div>
							<el-input v-model="unloadList[0].lorlUnlRemark" class="platItemRigth" placeholder="请输入"
								:disabled="planUnloadeditisReadOnly" />
						</div>
					</div>
				</div>

				<div class="flex">
					<div class="rpt_tit">
						<p class="platTitle">实际卸货数据
							<span class="auditwait" v-if="unloadList[0].lorlChkStatus=='0'">待审核</span>
							<span class="auditpass" v-else-if="unloadList[0].lorlChkStatus=='1'">审核通过</span>
							<span class="auditnopass" v-else-if="unloadList[0].lorlChkStatus=='2'">审核不通过</span>
							<span class="auditpass" v-else>未提交</span>
						</p>
					</div>
					<div class="editimg fontSize18" style="text-decoration: underline;" v-if="permissionItem.audit">
						<div v-if="unloadedit" class="flex">
							<div class="mr-10" @click="unloadeditsave">保存</div>
							<div class="mr-10" @click="unloadeditChange(false)">取消</div>
						</div>
						<div class="mr-10" @click="unloadeditChange(true)"
							v-if="unloadList[0].lorlChkStatus=='0'&&!unloadedit">编辑</div>
						<div v-if="unloadList[0].lorlChkStatus=='0'"
							@click="handleAudits('unload',unloadList[0].lorlId)">审核
						</div>
					</div>
				</div>
				<div class="info-input-container">
					<div class="flex flex-y-center flex-wrap">
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>卸货到站时间</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="unloadList[0].lorlUnlsTime" type="datetime" :clearable="false"
									placeholder="请选择卸货到站时间" style="width: 100%;" :readonly="unloadeditisReadOnly">
								</el-date-picker>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>卸货开始时间:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="unloadList[0].lorlUnlStartTime" type="datetime"
									:clearable="false" placeholder="请选择卸货开始时间" style="width: 100%;"
									:readonly="unloadeditisReadOnly">
								</el-date-picker>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>卸货离站时间:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="unloadList[0].lorlUnlOffsiteTime" type="datetime"
									:clearable="false" placeholder="请选择卸货离站时间" style="width: 100%;"
									:readonly="unloadeditisReadOnly">
								</el-date-picker>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>实际卸货吨位（吨）:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-input v-model="unloadList[0].lorlUnlsWeight" placeholder="请输入" type="number"
									:readonly="unloadeditisReadOnly" />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>重车里程（KM）:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-input v-model="unloadList[0].lorlUnlHeaMilag" placeholder="请输入" type="number"
									readonly />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>途损量（吨）:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-input v-model="unloadList[0].lorlLossWeight" placeholder="请输入" type="number"
									readonly />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>卸货磅单编号:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-input v-model="unloadList[0].lorlUnlPound" placeholder="请输入"
									:readonly="unloadeditisReadOnly" />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>表显里程（卸货）:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-input v-model="unloadList[0].lorlUnlOdometer" placeholder="请输入" type="number"
									:readonly="unloadeditisReadOnly" />
							</div>
						</div>

						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>备注:</span>
							</div>
							<el-input v-model="unloadList[0].lorlSubmitRemark" class="platItemRigth" placeholder="请输入"
								:readonly="unloadeditisReadOnly" />
						</div>
						<div class="w50 flex flex-y-center platItem">
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>表显里程照片:</span>
							</div>
							<div class="upRpic_icon_item2"
								v-if="unloadList[0].lorlUnlOdoUrl == ''||unloadList[0].lorlUnlOdoUrl == null">
								<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
							</div>
							<div class="upRpic_icon_item2" v-viewer v-else>
								<img class="upRpic2_icon" :src="unloadList[0].lorlUnlOdoUrl" />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>卸货磅单照片:</span>
							</div>
							<div class="upRpic_icon_item2"
								v-if="unloadList[0].lorlUnlPouUrl == ''||unloadList[0].lorlUnlPouUrl == null">
								<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
							</div>
							<div class="upRpic_icon_item2" v-viewer v-else>
								<img class="upRpic2_icon" :src="unloadList[0].lorlUnlPouUrl" />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>签收单照片:</span>
							</div>
							<div class="upRpic_icon_item2"
								v-if="unloadList[0].lorlUnlDeliveryUrl == ''||unloadList[0].lorlUnlDeliveryUrl == null">
								<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
							</div>
							<div class="upRpic_icon_item2" v-viewer v-else>
								<img class="upRpic2_icon" :src="unloadList[0].lorlUnlDeliveryUrl" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 费用项目 -->
			<div v-show="index==2" class="custUpWarp" style="max-height: 500px; overflow: auto" ref="reflore">
				<div v-for="(item, index) in expensesList" :key="index">
					<div class="flex">
						<div class="rpt_tit">
							<p class="platTitle">费用项目{{index+1}}
								<span class="auditwait" v-if="item.exoChkStatus=='0'">待审核</span>
								<span class="auditpass" v-else-if="item.exoChkStatus=='1'">审核通过</span>
								<span class="auditnopass" v-else-if="item.exoChkStatus=='2'">审核不通过</span>
							</p>
						</div>
						<div class="editimg fontSize18" style="text-decoration: underline;"
							v-if="permissionItem.auditfee">
							<div v-if="item.loreedit" class="flex">
								<div class="mr-10" @click="loreeditsave(item)">保存</div>
								<div class="mr-10" @click="loreeditChange(item,false)">取消</div>
							</div>
							<div class="mr-10" @click="loreeditChange(item,true)"
								v-if="item.exoChkStatus=='0'&&!item.loreedit">编辑
							</div>
							<div v-if="item.exoChkStatus=='0'" style="text-decoration: underline;"
								@click="handleAudits('expenses',item.exoId)">审核</div>
						</div>
					</div>
					<div class="info-input-container">
						<div class="flex flex-y-center flex-wrap">
							<div class="w50 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>费用类型:</span>
								</div>
								<div class="flex platItemRigth flex-y-center">
									<el-select v-model="item.exoType" placeholder="请选择"
										@change="bindloreTypeChange(item.exoType,index)" disabled>
										<el-option v-for="(subitem, subindex) in loreTypeList" :key="subitem.typeId"
											:label="subitem.typeName" :value="subitem.typeId">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="w50 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>费用子项:</span>
								</div>
								<div class="flex platItemRigth flex-y-center">
									<el-select v-model="item.exoiSubtype" placeholder="请选择"
										@change="bindloreSubTypeChange(item.exoiSubtype,index)" disabled>
										<el-option v-for="(subitem, subindex) in item.loreSubTypeList"
											:key="subitem.typeSubId" :label="subitem.typeSubName"
											:value="subitem.typeSubId">
										</el-option>
									</el-select>
								</div>
							</div>
							<div class="w50 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>发生时间</span>
								</div>
								<div class="flex platItemRigth flex-y-center">
									<el-date-picker v-model="item.exoiPayTime" type="datetime" :clearable="false"
										placeholder="请选择计划到站时间" style="width: 100%;" disabled>
									</el-date-picker>
								</div>
							</div>
							<div class="w50 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>发生地址:</span>
								</div>
								<el-input v-model="item.exoiPayAddr" class="platItemRigth" placeholder="请输入" disabled />
							</div>
							<div class="w50 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>数量:</span>
								</div>
								<div class="flex platItemRigth flex-y-center">
									<el-input v-model="item.exoiCount" placeholder="请输入" type="number"
										:disabled="item.loreeditisReadOnly" />
								</div>
							</div>
							<div class="w50 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>费用金额:</span>
								</div>
								<div class="flex platItemRigth flex-y-center">
									<el-input v-model="item.exoiSumPrice" placeholder="请输入" type="number"
										:disabled="item.loreeditisReadOnly" />
								</div>
							</div>
							<div class="w50 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>支付类型</span>
								</div>
								<div class="flex platItemRigth flex-y-center">
									<el-select v-model="item.exoAdvanceType" placeholder="请选择支付类型" disabled>
										<el-option label="公司定点费用" value="0" />
										<el-option label="垫付费用" value="1" />
									</el-select>
								</div>
							</div>
							<div class="w50 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>费用说明:</span>
								</div>
								<el-input v-model="item.exoDescribe" class="platItemRigth" placeholder="请输入" disabled />
							</div>
							<div class="w50 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>表显里程数:</span>
								</div>
								<div class="flex platItemRigth flex-y-center">
									<el-input v-model="item.exoiOdometer" placeholder="请输入" type="number" disabled />
								</div>
							</div>
							<div class="w50 flex flex-y-center platItem">
							</div>
							<div class="w50 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>表显里程照片:</span>
								</div>
								<div class="upRpic_icon_item2" v-if="item.exoiOdoUrl == ''||item.exoiOdoUrl == null">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
								</div>
								<div class="upRpic_icon_item2" v-viewer v-else>
									<img class="upRpic2_icon" :src="item.exoiOdoUrl" />
								</div>
							</div>
							<div class="w50 flex flex-y-center platItem">
								<div class="flex flex-y-center platItemLeft">
									<span class="input-fail">*</span>
									<span>附件照片:</span>
								</div>
								<div class="upRpic_icon_item2"
									v-if="item.exoiReceiptUrl == ''||item.exoiReceiptUrl == null">
									<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
								</div>
								<div class="upRpic_icon_item2" v-viewer v-else>
									<img class="upRpic2_icon" :src="item.exoiReceiptUrl" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-show="index==3" class="custUpWarp" style="max-height: 500px; overflow: auto">
				<div class="flex">
					<div class="rpt_tit">
						<p class="platTitle">车辆信息</p>
					</div>
					<!-- <div class="editimg fontSize18">
						<div v-if="vehedit" class="flex">
							<div class="mr-10" @click="veheditsave">保存</div>
							<div @click="veheditChange(false)">取消</div>
						</div>
						<div @click="veheditChange(true)" v-else>编辑</div>
					</div> -->
				</div>
				<div class="info-input-container">
					<div class="flex flex-y-center flex-wrap">
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>牵引车牌号:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-select v-model="lorVehHeadId" placeholder="请选择" disabled>
									<el-option v-for="(item, index) in vehHeadList" :key="index" :label="item.vehNo"
										:value="item.vehId">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>挂车车牌号:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-select v-model="lorVehTailId" placeholder="请选择" disabled>
									<el-option v-for="(item, index) in vehTailList" :key="index" :label="item.vehNo"
										:value="item.vehId">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>主驾</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-select v-model="lorMdriveId" placeholder="请选择" @change="vehicleMUserChange"
									disabled>
									<el-option v-for="(item, index) in driList" :key="item.driUserId"
										:label="item.driName" :value="item.driUserId">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>押运员:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-select v-model="lorYayunId" placeholder="请选择" @change="vehicleYUserChange" disabled>
									<el-option v-for="(item, index) in yyList" :key="item.yyUserId" :label="item.yyName"
										:value="item.yyUserId">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>主驾电话:</span>
							</div>
							<el-input v-model="vehicleMUserPhone" class="platItemRigth" placeholder="请输入" readonly />
						</div>
						<!-- <div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>副驾:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-input v-model="unloadList[0].lorlEndContact" placeholder="请输入" />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>副驾电话:</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-input v-model="unloadList[0].lorlEndPhone" placeholder="请输入" />
							</div>
						</div> -->

						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>押运员电话:</span>
							</div>
							<el-input v-model="vehicleYUserPhone" class="platItemRigth" placeholder="请输入" readonly />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>随车电话:</span>
							</div>
							<el-input v-model="unloadList[0].lorlUnlRemark" class="platItemRigth" placeholder="请输入"
								readonly />
						</div>
					</div>
				</div>

				<div class="flex">
					<div class="rpt_tit">
						<p class="platTitle">车辆轨迹</p>
					</div>
					<!-- <div class="editimg fontSize18">
						<div v-if="vehedit" class="flex">
							<div class="mr-10" @click="veheditsave">保存</div>
							<div @click="veheditChange(false)">取消</div>
						</div>
						<div @click="veheditChange(true)" v-else>编辑</div>
					</div> -->
				</div>
				<div class="info-input-container">
					<div class="flex flex-y-center flex-wrap">

					</div>
				</div>
			</div>

			<div v-show="index==4" class="custUpWarp" style="max-height: 500px; overflow: auto">
				<div class="flex">
					<div class="rpt_tit">
						<p class="platTitle">运费收入
							<span class="auditwait" v-if="lorFreightChkStatus=='0'">待审核</span>
							<span class="auditpass" v-else-if="lorFreightChkStatus=='1'">审核通过</span>
							<span class="auditpass" v-else></span>
						</p>
					</div>
					<div class="editimg fontSize18" style="text-decoration: underline;" v-if="permissionItem.editfee">
						<div v-if="lorFixededit" class="flex">
							<div class="mr-10" @click="lorFixededitsave">保存</div>
							<div class="mr-10" @click="lorFixededitChange(false)">取消</div>
						</div>
						<div class="mr-10" @click="lorFixededitChange(true)"
							v-if="lorFreightChkStatus!=='1'&&!lorFixededit">编辑</div>
						<div v-if="lorFreightChkStatus=='0'&&permissionItem.auditfee" @click="FreightChk(lorId)">审核
						</div>
					</div>
				</div>
				<div class="info-input-container">
					<div class="flex flex-y-center flex-wrap">
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>运费里程:</span>
							</div>
							<el-input v-model="lorFixedMilage" class="platItemRigth" placeholder="请输入" type="number"
								:readonly="lorFixededitisReadOnly" />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>运费单价:</span>
							</div>
							<el-input v-model="lorFixedPrice" class="platItemRigth" placeholder="请输入" type="number"
								:readonly="lorFixededitisReadOnly" />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>运费吨位（吨）:</span>
							</div>
							<el-input v-model="lorFreightWeight" class="platItemRigth" placeholder="请输入" type="number"
								:readonly="lorFixededitisReadOnly" @mousewheel.native.prevent />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>运费收入:</span>
							</div>
							<el-input v-model="lorFreightMoney" class="platItemRigth" placeholder="请输入" type="number"
								readonly />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>装货磅单照片:</span>
							</div>
							<div class="upRpic_icon_item2" v-if="lorLoadPouUrl == ''||lorLoadPouUrl == null">
								<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
							</div>
							<div class="upRpic_icon_item2" v-viewer v-else>
								<img class="upRpic2_icon" :src="lorLoadPouUrl" />
							</div>
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>卸货磅单照片:</span>
							</div>
							<div class="upRpic_icon_item2"
								v-if="unloadList[0].lorlUnlPouUrl == ''||unloadList[0].lorlUnlPouUrl == null">
								<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
							</div>
							<div class="upRpic_icon_item2" v-viewer v-else>
								<img class="upRpic2_icon" :src="unloadList[0].lorlUnlPouUrl" />
							</div>
						</div>
					</div>
				</div>
				<div class="flex">
					<div class="rpt_tit">
						<p class="platTitle">其他收入</p>
					</div>
				</div>
				<div class="info-input-container">
					<div class="flex flex-y-center flex-wrap">
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>压车费收入:</span>
							</div>
							<el-input v-model="lorOccupyIncome" class="platItemRigth" placeholder="请输入" type="number"
								:readonly="lorFixededitisReadOnly" />
						</div>
						<div class="w50 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>分卸费收入:</span>
							</div>
							<el-input v-model="lorUnloadIncome" class="platItemRigth" placeholder="请输入" type="number"
								:readonly="lorFixededitisReadOnly" />
						</div>
					</div>
				</div>
			</div>

			<el-dialog title="审核" v-model="isAudit" width="30%" center>
				<div class="mar-bot-20"><span style="color: red">*</span>审核意见</div>
				<div style="width: 100%; height: 80px">
					<el-input type="textarea" v-model="auditsRemark" placeholder="请输入审核意见"></el-input>
				</div>
				<div class="btn_warp">
					<div class="btn-outline1" @click="Auditssubmit(1)">不通过</div>
					<div class="btn-outline2" @click="Auditssubmit(0)">通过</div>
				</div>
			</el-dialog>

			<span class="footer_btn_warp">
				<span class="cancle_btn" v-on:click="closeModal()">关闭</span>
			</span>

		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		computed,
		getCurrentInstance,
		onMounted,
		nextTick,
		watch,
	} from "vue";
	import {
		parseTime,
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	export default defineComponent({
		name: "Detail",
		emits: ["getData"],

		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "waybillManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "waybillManage:add") {
						data.permissionItem.add = true;
					}
					if (el == "waybillManage:edit") {
						data.permissionItem.edit = true;
					}
					if (el == "waybillManage:del") {
						data.permissionItem.del = true;
					}
					if (el == "waybillManage:audit") {
						data.permissionItem.audit = true;
					}
					if (el == "waybillManage:auditfee") {
						data.permissionItem.auditfee = true;
					}
					if (el == "waybillManage:fee") {
						data.permissionItem.fee = true;
					}
					if (el == "waybillManage:editfee") {
						data.permissionItem.editfee = true;
					}
				});

				nextTick(() => {
					getProviderTYList(); //获取托运商
					getProviderMYList(); //获取贸易商
					getDirList(); //获取主驾司机
					getYyList(); //获取押运员
					//getSiteList(); //获取站点
					getVehHeadList(); //获取牵引车辆
					getVehTailList(); //获取挂车车辆
				});
			});

			const data = reactive({
				isDetail: false,
				index: 0,
				isAudit: false,
				auditsRemark: "",
				auditsType: "",
				auditsid: "",

				loadedit: false,
				loadeditisReadOnly: true,
				unloadedit: false,
				unloadeditisReadOnly: true,
				planUnloadedit: false,
				planUnloadeditisReadOnly: true,
				lorFixededit: false,
				lorFixededitisReadOnly: true,

				permissionItem: {
					list: false,
					add: false,
					edit: false,
					del: false,
					audit: false,
					auditfee: false,
					fee: false,
					editfee: false,
				},


				loreTypeList: [{
						typeName: "高速费",
						typeId: "0",
						loreSubTypeList: [{
							typeSubName: "高速费",
							typeSubId: "0"
						}]
					},
					{
						typeName: "路桥费",
						typeId: "1",
						loreSubTypeList: [{
							typeSubName: "路桥费",
							typeSubId: "0"
						}]
					},
					{
						typeName: "燃料费",
						typeId: "2",
						loreSubTypeList: [{
							typeSubName: "加气费",
							typeSubId: "0"
						}]
					},
					{
						typeName: "维修费",
						typeId: "3",
						loreSubTypeList: [{
							typeSubName: "维修费",
							typeSubId: "0"
						}]
					},
					{
						typeName: "停车费",
						typeId: "4",
						loreSubTypeList: [{
							typeSubName: "停车费",
							typeSubId: "0"
						}]
					}
				],

				ProviderTYList: [], //所属托运商
				ProviderMYList: [], //所属贸易商
				vehHeadList: [],
				vehTailList: [],
				vehicleMUserPhone: "",
				vehicleYUserPhone: "",
				driList: [],
				yyList: [],
				siteList: [],
				loadsiteList: [],
				unloadsiteList: [],

				lorId: "",
				lorStatus: "",
				lorType: "0",
				lorCarrier: "TOP", //承运商ID
				lorCarrierType: "1", //承运商机构类型：0客商机构；1主机构；
				lorShipper: "", //托运商ID 
				lorShipperType: "0", //托运商机构类型：0客商机构；1主机构；
				lorSupplier: "", //供应商ID
				lorSupplierType: "0", //供应商机构类型：0客商机构；1主机构；
				lorGoods: "", //货品ID 
				lorLoadType: "0", //装卸类型：0单装单卸，1单装多卸
				lorLoadWhid: null, //装货站点ID
				lorLoadName: "",
				lorLoadAddr: "", //装货地址
				lorLoadLnglat: "", //装货经纬度
				lorLoadContact: "",
				lorLoadPhone: "",
				lorLoadContact2: "",
				lorLoadPhone2: "",
				lorLoadRemark: "",
				lorLoadpTime: "", //计划装货时间
				lorLoadpWeight: "", //计划装货吨位
				lorVehicleId: null, //运力车辆
				lorVehHeadId: null, //牵引车
				lorVehHeadNo: "", //牵引车牌
				lorVehTailId: null, //挂车
				lorVehTailNo: "", //挂车车牌
				lorMdriveId: null, //主驾
				lorSdriveId: null, //副驾
				lorYayunId: null, //押运员
				lorRemark: "",
				lorFixedMilage: "", //运费里程
				lorFixedPrice: "", //运费单价
				lorFreightWeight: "", //运费吨位
				lorFixedSumPrice: "", //一口价运费
				lorFreightMoney: "", //运费收入
				lorOccupyIncome: "", //压车费收入
				lorUnloadIncome: "", //分卸费收入
				lorLoadFinishTime: "", //实际装货完成时间
				lorLoadsTime: "", //实际到站装货时间
				lorLoadStartTime: "", //实际开始装货时间
				lorLoadOffsiteTime: "", //实际装货离站时间
				lorLoadsWeight: "", //实际装货吨位
				lorLoadEmpMilage: "", //空车里程
				lorLoadPound: "", //磅单编号
				lorSubmitRemark: "", //装货备注
				lorLoadOdometer: "", //表显里程数
				lorFreightChkStatus: null, //运费审核状态
				expensesChkCount: 0, //费用待审核数量
				loadChkCount: 0, //装货待审核数量
				unloadChkCount: 0, //卸货待审核数量
				lorLoadOdoUrl: "", //表显里程照片
				lorLoadPouUrl: "", //磅单照片
				lorChkStatus: "", ////装货审核状态：0待审核；1审核通过；2审核不通过 空为没提交
				unloadList: [{
					lorlId: "",
					lorlSort: 1,
					lorlEndWhid: null, //卸货站点ID
					lorlEndName: "",
					lorlEndAddr: "",
					lorlEndPcode: "450000",
					lorlEndCcode: "451200",
					lorlEndAcode: "451227",
					lorlEndLnglat: "",
					lorlEndContact: "",
					lorlEndPhone: "",
					lorlEndContact2: "",
					lorlEndPhone2: "",
					lorlUnlpTime: "",
					lorlUnlpWeight: "",
					lorlUnlRemark: "",
					lorlUnlPound: "", //卸货磅单
					lorlUnlsTime: "", //实际到站卸货时间
					lorlUnlsWeight: "", //实际卸货吨位
					lorlUnlStartTime: "", //卸货开始时间
					lorlUnlFinishTime: "", //卸货完成时间
					lorlUnlOffsiteTime: "", //卸货离站时间
					lorlLossWeight: "", //途损量
					lorlUnlHeaMilag: "", //重车里程
					lorlUnlOdometer: "",
					lorlUnlOdoUrl: "",
					lorlUnlPouUrl: "",
					lorlUnlDeliveryUrl: "",
					lorlChkStatus: "", //卸货审核状态：0待审核；1审核通过；2审核不通过
					lorlSubmitRemark: "", //卸货备注
				}],
				expensesList: [{
					exoId: "",
					exoCretime: "", //创建时间
					exoDescribe: "", //费用说明
					exoiHaveInvoice: 1, //是否有发票
					exoiGoods: "", //商品
					exoiCount: "", //数量
					exoType: "", //费用类型
					exoiSubtype: "", //费用子项目
					exoAdvanceType: "", //支付类型0公司固定点费用 1垫付
					exoName: "", //费用名称
					exoiName: "", //费用子项目名称
					exoiSumPrice: "", //总费用
					exoiPayTime: "", //支付时间
					exoiPayAddr: "", //支付地址
					exoiOdometer: "", //表显里程数
					exoiOdoUrl: "", //表显里程照片
					exoiReceiptUrl: "", //附件照片
					exoChkStatus: "", //费用审核状态：0未审核，1审核通过，2审核不通过
					loreSubTypeList: [] //对应每项费用子项目列表
				}],
			});

			watch(() => data.unloadList[0].lorlUnlOdometer, (newValue, oldValue) => {
				console.log('lorlUnlHeaMilag changed:', newValue);
				setlorlUnlHeaMilag(data.lorLoadOdometer, newValue);
			});

			watch(() => data.unloadList[0].lorlUnlsWeight, (newValue, oldValue) => {
				console.log('lorlUnlsWeight changed:', newValue);
				setlorlLossWeight(newValue, data.lorLoadsWeight);
			});

			//计算重车里程
			const setlorlUnlHeaMilag = async (AValue, BValue) => {
				if (!validateNumber(String(AValue))) {
					return;
				}

				if (!validateNumber(String(BValue))) {
					return;
				}

				if (Number(BValue) >= Number(AValue)) {
					data.unloadList[0].lorlUnlHeaMilag = Number(BValue) - Number(AValue);
				} else {
					data.unloadList[0].lorlUnlHeaMilag = 0;
				}
			};
			//计算途损吨位
			const setlorlLossWeight = async (AValue, BValue) => {
				if (!validateNumber(String(AValue))) {
					return;
				}

				if (!validateNumber(String(BValue))) {
					return;
				}

				if (Number(BValue) >= Number(AValue)) {
					data.unloadList[0].lorlLossWeight = Number(BValue) - Number(AValue);
				} else {
					data.unloadList[0].lorlLossWeight = 0;
				}
			};

			//重置数据
			const init = async (id, index) => {
				data.isDetail = true;
				data.index = index;
				data.lorId = id;

				data.loadedit = false;
				data.loadeditisReadOnly = true;
				data.unloadedit = false;
				data.unloadeditisReadOnly = true;
				data.planUnloadedit = false;
				data.planUnloadeditisReadOnly = true;
				data.lorFixededit = false;
				data.lorFixededitisReadOnly = true;

				let params = {
					lorId: id,
				};
				const r = await proxy.$http.get(apiObj.ordDetail, params);
				if (r) {
					data.lorType = r.orderInfo.lorType;
					data.lorStatus = r.orderInfo.lorStatus;
					data.lorCarrier = r.orderInfo.lorCarrier;
					data.lorCarrierType = r.orderInfo.lorCarrierType;
					data.lorShipper = r.orderInfo.lorShipper;
					getloadSiteList(data.lorShipper);
					getunloadSiteList(data.lorShipper);
					data.lorShipperType = r.orderInfo.lorShipperType;
					data.lorSupplier = r.orderInfo.lorSupplier;
					data.lorSupplierType = r.orderInfo.lorSupplierType;
					data.lorGoods = r.orderInfo.lorGoods;
					data.lorLoadType = r.orderInfo.lorLoadType;
					data.lorLoadWhid = r.orderInfo.lorLoadWhid;
					data.lorLoadName = r.orderInfo.lorLoadName;
					data.lorLoadAddr = r.orderInfo.lorLoadAddr;
					data.lorLoadLnglat = r.orderInfo.lorLoadLnglat;
					data.lorLoadContact = r.orderInfo.lorLoadContact;
					data.lorLoadPhone = r.orderInfo.lorLoadPhone;
					data.lorLoadContact2 = r.orderInfo.lorLoadContact2;
					data.lorLoadPhone2 = r.orderInfo.lorLoadPhone2;
					data.lorLoadRemark = r.orderInfo.lorLoadRemark;
					data.lorLoadpTime = r.orderInfo.lorLoadpTime;
					data.lorLoadpWeight = r.orderInfo.lorLoadpWeight;
					data.lorVehicleId = r.orderInfo.lorVehicleId;
					data.lorVehHeadId = r.orderInfo.lorVehHeadId;
					data.lorVehHeadNo = r.orderInfo.lorVehHeadNo;
					data.lorVehTailId = r.orderInfo.lorVehTailId;
					data.lorVehTailNo = r.orderInfo.lorVehTailNo;
					data.lorMdriveId = r.orderInfo.lorMdriveId;
					data.lorSdriveId = r.orderInfo.lorSdriveId;
					data.lorYayunId = r.orderInfo.lorYayunId;
					data.vehicleMUserPhone = r.orderInfo.odrMDirPhone;
					data.vehicleYUserPhone = r.orderInfo.odrYayunPhone;
					data.lorRemark = r.orderInfo.lorRemark;
					data.lorFixedMilage = r.orderInfo.lorFixedMilage;
					data.lorFixedPrice = r.orderInfo.lorFixedPrice;
					data.lorFreightWeight = r.orderInfo.lorFreightWeight;
					data.lorFixedSumPrice = r.orderInfo.lorFixedSumPrice;
					data.lorFreightMoney = r.orderInfo.lorFreightMoney;
					data.lorOccupyIncome = r.orderInfo.lorOccupyIncome;
					data.lorUnloadIncome = r.orderInfo.lorUnloadIncome;
					data.lorLoadStartTime = r.orderInfo.lorLoadStartTime;
					data.lorLoadOffsiteTime = r.orderInfo.lorLoadOffsiteTime;
					data.lorLoadFinishTime = r.orderInfo.lorLoadFinishTime;
					data.lorLoadsTime = r.orderInfo.lorLoadsTime;
					data.lorLoadsWeight = r.orderInfo.lorLoadsWeight;
					data.lorLoadEmpMilage = r.orderInfo.lorLoadEmpMilage;
					data.lorLoadPound = r.orderInfo.lorLoadPound;
					data.lorLoadOdometer = r.orderInfo.lorLoadOdometer;
					data.lorSubmitRemark = r.orderInfo.lorSubmitRemark;
					data.expensesChkCount = r.orderInfo.expensesChkCount;
					data.lorFreightChkStatus = r.orderInfo.lorFreightChkStatus;
					data.loadChkCount = r.orderInfo.loadChkCount;
					data.unloadChkCount = r.orderInfo.unloadChkCount;
					data.lorLoadOdoUrl = r.orderInfo.lorLoadOdoUrl;
					data.lorLoadPouUrl = r.orderInfo.lorLoadPouUrl;
					data.lorChkStatus = r.orderInfo.lorChkStatus;
					data.unloadList = [];
					r.orderInfo.unloadList.forEach((el) => {
						data.unloadList.push({
							lorlId: el.lorlId,
							lorlSort: el.lorlSort,
							lorlEndWhid: el.lorlEndWhid, //卸货站点ID
							lorlEndName: el.lorlEndName,
							lorlEndAddr: el.lorlEndAddr,
							lorlEndPcode: "450000",
							lorlEndCcode: "451200",
							lorlEndAcode: "451227",
							lorlEndLnglat: el.lorlEndLnglat,
							lorlEndContact: el.lorlEndContact,
							lorlEndPhone: el.lorlEndPhone,
							lorlEndContact2: el.lorlEndContact2,
							lorlEndPhone2: el.lorlEndPhone2,
							lorlUnlpTime: el.lorlUnlpTime,
							lorlUnlpWeight: el.lorlUnlpWeight,
							lorlUnlRemark: el.lorlUnlRemark,
							lorlUnlPound: el.lorlUnlPound,
							lorlUnlsTime: el.lorlUnlsTime,
							lorlUnlsWeight: el.lorlUnlsWeight,
							lorlUnlFinishTime: el.lorlUnlFinishTime,
							lorlUnlOffsiteTime: el.lorlUnlOffsiteTime,
							lorlUnlStartTime: el.lorlUnlStartTime,
							lorlLossWeight: el.lorlLossWeight,
							lorlUnlHeaMilag: el.lorlUnlHeaMilag,
							lorlUnlOdometer: el.lorlUnlOdometer,
							lorlUnlOdoUrl: el.lorlUnlOdoUrl,
							lorlUnlPouUrl: el.lorlUnlPouUrl,
							lorlUnlDeliveryUrl: el.lorlUnlDeliveryUrl,
							lorlChkStatus: el.lorlChkStatus,
							lorlSubmitRemark: el.lorlSubmitRemark,
						});
					});
					data.expensesList = [];
					r.orderInfo.expensesList.forEach((el) => {
						data.expensesList.push({
							exoId: el.exoId,
							exoCretime: el.exoCretime,
							exoDescribe: el.exoDescribe,
							exoiHaveInvoice: el.itemList[0].exoiHaveInvoice,
							exoiGoods: el.itemList[0].exoiGoods,
							exoiCount: el.itemList[0].exoiCount,
							exoType: el.exoType,
							exoiSubtype: el.itemList[0].exoiSubtype,
							exoAdvanceType: el.exoAdvanceType,
							exoName: el.exoName,
							exoiName: el.itemList[0].exoiName,
							exoiSumPrice: el.itemList[0].exoiSumPrice,
							exoiPayTime: el.itemList[0].exoiPayTime,
							exoiPayAddr: el.itemList[0].exoiPayAddr,
							exoiOdometer: el.itemList[0].exoiOdometer,
							exoiOdoUrl: el.itemList[0].exoiOdoUrl,
							exoiReceiptUrl: el.itemList[0].exoiReceiptUrl,
							exoChkStatus: el.exoChkStatus,
							loreSubTypeList: data.loreTypeList[el.exoType].loreSubTypeList,
							loreedit: false,
							loreeditisReadOnly: true,
						});
					});

					setlorlUnlHeaMilag(data.lorLoadOdometer, data.unloadList[0].lorlUnlOdometer);
					setlorlLossWeight(data.unloadList[0].lorlUnlsWeight, data.lorLoadsWeight);
				}

			};

			//编辑实际装货信息
			const loadeditsave = async () => {
				if (!data.permissionItem.audit) {
					proxy.$message.error("没有运单审核权限！");
					return;
				}

				if (data.lorLoadPound == "" || data.lorLoadPound == null) {
					proxy.$message.error("请填写装货磅单编号");
					return;
				}
				if (data.lorLoadsWeight == "" || data.lorLoadsWeight == null) {
					proxy.$message.error("请填写实际装货吨位");
					return;
				}
				if (Number(data.lorLoadsWeight) > 23) {
					proxy.$message.error("请输入实际装货吨位小于23以内的数字");
					return;
				}
				// if (data.lorLoadEmpMilage == "" || data.lorLoadEmpMilage == null) {
				// 	proxy.$message.error("请填写空车里程");
				// 	return;
				// }
				if (data.lorLoadOdometer == "" || data.lorLoadOdometer == null) {
					proxy.$message.error("请填写表显里程");
					return;
				}

				let params = {
					lorId: data.lorId,
					oprType: "0", //操作类型：0装货，1卸货
					realWeight: data.lorLoadsWeight,
					// empMilage: data.lorLoadEmpMilage,
					odometer: data.lorLoadOdometer,
					poundNo: data.lorLoadPound,
				};

				const r = await proxy.$http.post(apiObj.orderLoadUpdate, params)
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					init(data.lorId, data.index);
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			//编辑实际卸货信息
			const unloadeditsave = async () => {
				if (!data.permissionItem.audit) {
					proxy.$message.error("没有运单审核权限！");
					return;
				}

				if (data.unloadList[0].lorlUnlPound == "" || data.unloadList[0].lorlUnlPound == null) {
					proxy.$message.error("请填写卸货磅单编号");
					return;
				}
				if (data.unloadList[0].lorlUnlsWeight == "" || data.unloadList[0].lorlUnlsWeight == null) {
					proxy.$message.error("请填写实际卸货吨位");
					return;
				}
				if (Number(data.unloadList[0].lorlUnlsWeight) > 23) {
					proxy.$message.error("请输入实际卸货吨位小于23以内的数字");
					return;
				}
				// if (data.unloadList[0].lorlUnlHeaMilag == "" || data.unloadList[0].lorlUnlHeaMilag == null) {
				// 	proxy.$message.error("请填写重车里程");
				// 	return;
				// }
				if (data.unloadList[0].lorlUnlOdometer == "" || data.unloadList[0].lorlUnlOdometer ==
					null) {
					proxy.$message.error("请填写表显里程");
					return;
				}

				let params = {
					lorId: data.lorId,
					lorlId: data.unloadList[0].lorlId,
					oprType: "1", //操作类型：0装货，1卸货
					realWeight: data.unloadList[0].lorlUnlsWeight,
					// lossWeight: data.unloadList[0].lorlLossWeight,
					// heaMilag: data.unloadList[0].lorlUnlHeaMilag,
					odometer: data.unloadList[0].lorlUnlOdometer,
					poundNo: data.unloadList[0].lorlUnlPound,
				};

				const r = await proxy.$http.post(apiObj.orderUnloadUpdate, params)
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					init(data.lorId, data.index);
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			//编辑计划卸货信息
			const planUnloadeditsave = async () => {
				if (!data.permissionItem.edit) {
					proxy.$message.error("没有运单编辑权限！");
					return;
				}

				if (data.unloadList[0].lorlEndWhid === "" || data.unloadList[0].lorlEndWhid == null) {
					proxy.$message.error("请选择卸货站点");
					return;
				}
				if (data.unloadList[0].lorlUnlpTime == "" || data.unloadList[0].lorlUnlpTime == null) {
					proxy.$message.error("请选择计划到站时间");
					return;
				}
				if (data.unloadList[0].lorlUnlpWeight == "" || data.unloadList[0].lorlUnlpWeight == null) {
					proxy.$message.error("请填写计划卸货吨位");
					return;
				}
				if (Number(data.unloadList[0].lorlUnlpWeight) > 23) {
					proxy.$message.error("请输入计划卸货吨位小于23以内的数字");
					return;
				}
				if (data.unloadList[0].lorlEndContact == "" || data.unloadList[0].lorlEndContact == null) {
					proxy.$message.error("请填写收货人");
					return;
				}
				if (data.unloadList[0].lorlEndPhone == "" || data.unloadList[0].lorlEndPhone == null) {
					proxy.$message.error("请填写收货人电话");
					return;
				}

				let params = {
					lorId: data.lorId,
					unloadList: [{
						lorlId: data.unloadList[0].lorlId,
						lorlEndWhid: data.unloadList[0].lorlEndWhid,
						lorlEndName: data.unloadList[0].lorlEndName,
						lorlEndAddr: data.unloadList[0].lorlEndAddr,
						lorlEndPcode: data.unloadList[0].lorlEndPcode,
						lorlEndCcode: data.unloadList[0].lorlEndCcode,
						lorlEndAcode: data.unloadList[0].lorlEndAcode,
						lorlEndLnglat: data.unloadList[0].lorlEndLnglat,
						lorlEndContact: data.unloadList[0].lorlEndContact,
						lorlEndPhone: data.unloadList[0].lorlEndPhone,
						lorlEndContact2: data.unloadList[0].lorlEndContact2,
						lorlEndPhone2: data.unloadList[0].lorlEndPhone2,
						lorlUnlpTime: data.unloadList[0].lorlUnlpTime,
						lorlUnlpWeight: data.unloadList[0].lorlUnlpWeight,
						lorlUnlRemark: data.unloadList[0].lorlUnlRemark,
					}],
				};

				const r = await proxy.$http.post(apiObj.updateUnlLineInfo, params)
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					init(data.lorId, data.index);
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			//编辑支出信息
			const loreeditsave = async (item) => {


				if (item.exoAdvanceType === "" || item.exoAdvanceType == null) {
					proxy.$message.error("请选择支持类型");
					return;
				}

				if (item.exoType === "" || item.exoType == null) {
					proxy.$message.error("请选择费用类型");
					return;
				}
				if (item.exoiSubtype === "" || item.exoiSubtype == null) {
					proxy.$message.error("请选择子费用类型");
					return;
				}
				if (item.exoiCount === "" || item.exoiCount == null) {
					proxy.$message.error("请填写数量");
					return;
				}
				if (item.exoiSumPrice === "" || item.exoiSumPrice == null) {
					proxy.$message.error("请填写费用金额");
					return;
				}
				if (item.exoiPayTime === '' || item.exoiPayTime == null) {
					proxy.$message.error("请选择费用发生时间");
					return;
				}
				if (item.exoiPayAddr === "" || item.exoiPayAddr == null) {
					proxy.$message.error("请填写费用地址");
					return;
				}

				let params = {
					exoId: item.exoId,
					exoAdvanceType: item.exoAdvanceType, //垫付类型：0定点费用，1垫付费用
					exoName: item.exoName, //费用单名称：
					exoType: item.exoType, //费用类型：0高速费1路桥费2燃料费3维修费
					exoDescribe: item.exoDescribe, //费用单说明
					itemList: [{
						exoiSubtype: item.exoiSubtype, //子费用类型：
						exoiName: item.exoiName, //费用名称
						exoiPrice: 0, //单价
						exoiCount: item.exoiCount, //数量：件数，加油量（升），加气量（千克）
						exoiGoods: item.exoiName, //货品名称
						exoiSumPrice: item.exoiSumPrice, //费用总金额
						exoiPayTime: item.exoiPayTime, //支付时间
						exoiPayAddr: item.exoiPayAddr, //支付地点
						exoiDescribe: item.exoiDescribe, //费用说明
						exoiHaveInvoice: item.exoiHaveInvoice, //有无发票：0无发票，1有发票
						exoiReceiptUrl: item.exoiReceiptUrl, //单据附件：图片，PDF
						exoiOdometer: item.exoiOdometer, //里程表数
						exoiOdoUrl: item.exoiOdoUrl //里程表照片
					}],

				};

				const r = await proxy.$http.post(apiObj.expensesOrderUpdate, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					init(data.lorId, data.index);
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}

			};

			//编辑运价信息
			const lorFixededitsave = async () => {
				if (!data.permissionItem.editfee) {
					proxy.$message.error("没有运单运费编辑权限！");
					return;
				}

				if (data.lorFixedMilage == "" || data.lorFixedMilage == null) {
					proxy.$message.error("请填写运费里程");
					return;
				}
				if (data.lorFixedPrice == "" || data.lorFixedPrice == null) {
					proxy.$message.error("请填写运费单价");
					return;
				}

				let params = {
					lorId: data.lorId,
					lorFixedMilage: data.lorFixedMilage,
					lorFixedPrice: data.lorFixedPrice,
					lorOccupyIncome: data.lorOccupyIncome,
					lorUnloadIncome: data.lorUnloadIncome,
					lorFreightWeight: data.lorFreightWeight,
				};

				const r = await proxy.$http.postFormData(apiObj.updateFreightInfo, params)
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					init(data.lorId, data.index);
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};


			//获取所属托运商
			const getProviderTYList = () => {
				let params = {
					page: 1,
					limit: 10000,
					searchWord: "",
					cocOrg: "",
					cocType: 1,
				};
				proxy.$http
					.get(apiObj.cusList, params, {
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						},
					})
					.then((res) => {
						if (res.code == 0) {
							data.ProviderTYList = res.rows;
						}
					});
			};
			//获取所属贸易商
			const getProviderMYList = async () => {
				let params = {
					page: 1,
					limit: 10000,
					searchWord: "",
					cocOrg: "",
					cocType: 2,
				};
				const res = await proxy.$http.get(apiObj.cusList, params);
				console.log(res);
				if (res.code == 0) {
					data.ProviderMYList = res.rows;
				}
			};

			//选择主驾驶员
			const getDirList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "1000",
				};
				const r = await proxy.$http.get(apiObj.drigetList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.driList = r.driList;
				}
			};
			//选择押运员
			const getYyList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "1000",
				};
				const r = await proxy.$http.get(apiObj.yygetList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.yyList = r.yayunList;
				}
			};

			//选择站点
			const getSiteList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "1000",
				};
				const r = await proxy.$http.get(apiObj.siteList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.siteList = r.rows;
				}
			};

			//选择装货站点
			const getloadSiteList = async (cocId) => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "10000",
					whProviderType: '0',
					whProvider: cocId,
					whType: 'gsloa'
				};
				const r = await proxy.$http.get(apiObj.siteList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.loadsiteList = r.rows;
				}
			};
			//选择卸货站点
			const getunloadSiteList = async (cocId) => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "10000",
					whProviderType: '0',
					whProvider: cocId,
					whType: 'gsunl'
				};
				const r = await proxy.$http.get(apiObj.siteList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.unloadsiteList = r.rows;
				}
			};

			//选择牵引车辆
			const getVehHeadList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "1000",
				};
				const r = await proxy.$http.get(apiObj.vehGetHeadList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehHeadList = r.vehList;
				}
			};
			//选择挂车车辆
			const getVehTailList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "1000",
				};
				const r = await proxy.$http.get(apiObj.vehGetTailList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehTailList = r.vehList;
				}
			};

			const bindloreTypeChange = async (selindex, index) => {
				data.expensesList[index].exoName = data.loreTypeList[selindex].typeName;
				data.expensesList[index].exoType = data.loreTypeList[selindex].typeId;
				data.expensesList[index].exoiGoods = data.loreTypeList[selindex].typeName;
				data.expensesList[index].loreSubTypeList = data.loreTypeList[selindex].loreSubTypeList;
				data.expensesList[index].exoiName = "";
				data.expensesList[index].exoiSubtype = "";
			};

			const bindloreSubTypeChange = async (selindex, index) => {
				data.expensesList[index].exoiName = data.expensesList[index].loreSubTypeList[selindex]
					.typeSubName;
				data.expensesList[index].exoiSubtype = data.expensesList[index].loreSubTypeList[selindex]
					.typeSubId;
			};

			const vehicleMUserChange = (value) => {
				const selectedItem = data.driList.find(item => item.driUserId === value);
				if (selectedItem) {
					data.vehicleMUserPhone = selectedItem.driPhone; // 更新其他参数的值。
				} else {
					data.vehicleMUserPhone = null; // 如果没有找到匹配项，则设置为null。
				}
			}
			const vehicleYUserChange = (value) => {
				const selectedItem = data.yyList.find(item => item.yyUserId === value);
				if (selectedItem) {
					data.vehicleYUserPhone = selectedItem.yyPhone; // 更新其他参数的值。
				} else {
					data.vehicleYUserPhone = null; // 如果没有找到匹配项，则设置为null。
				}
			}

			const navClick = (index) => {
				data.index = index;
			};

			const dialogClosedHandle = () => {
				data.isDetail = false;
			};
			const closeModal = () => {
				data.isDetail = false;
			};

			//运费审核
			const FreightChk = (lorId) => {
				if (!data.permissionItem.auditfee) {
					proxy.$message.error("没有运费审核权限！");
					return;
				}

				proxy
					.$confirm("您确定运费审核完成该运单吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							lorId: lorId,
						};
						const r = await proxy.$http.postFormData(apiObj.orderFreightChk, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
							init(data.lorId, data.index);
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			const handleAudits = async (type, id) => {

				if (type == 'load') {
					if (!data.permissionItem.audit) {
						proxy.$message.error("没有运单审核权限！");
						return;
					}
					if (data.lorLoadPound == "" || data.lorLoadPound == null) {
						proxy.$message.error("请填写装货磅单编号");
						return;
					}
					if (data.lorLoadsWeight == "" || data.lorLoadsWeight == null) {
						proxy.$message.error("请填写实际装货吨位");
						return;
					}
					if (Number(data.lorLoadsWeight) > 23) {
						proxy.$message.error("请输入实际装货吨位小于23以内的数字");
						return;
					}
					if (data.lorLoadOdometer == "" || data.lorLoadOdometer == null) {
						proxy.$message.error("请填写表显里程");
						return;
					}
				} else if (type == 'unload') {
					if (!data.permissionItem.audit) {
						proxy.$message.error("没有运单审核权限！");
						return;
					}
					if (data.unloadList[0].lorlUnlPound == "" || data.unloadList[0].lorlUnlPound == null) {
						proxy.$message.error("请填写卸货磅单编号");
						return;
					}
					if (data.unloadList[0].lorlUnlsWeight == "" || data.unloadList[0].lorlUnlsWeight ==
						null) {
						proxy.$message.error("请填写实际卸货吨位");
						return;
					}
					if (Number(data.unloadList[0].lorlUnlsWeight) > 23) {
						proxy.$message.error("请输入实际卸货吨位小于23以内的数字");
						return;
					}
					if (data.unloadList[0].lorlUnlOdometer == "" || data.unloadList[0].lorlUnlOdometer ==
						null) {
						proxy.$message.error("请填写表显里程");
						return;
					}
				} else if (type == 'unload') {
					if (!data.permissionItem.auditfee) {
						proxy.$message.error("没有运费审核权限！");
						return;
					}
				}

				data.isAudit = true;
				data.auditsType = type;
				data.auditsid = id;
				data.auditsRemark = "";
			};

			//审核
			const Auditssubmit = async (status) => {

				if (status == 1 && data.auditsRemark == "") {
					proxy.$message.error("请输入审核原因");
					return;
				}

				if (data.auditsType == 'load') {
					let params = {
						lorId: data.lorId,
						operate: status, //操作类型：0通过，1不通过
						remark: data.auditsRemark
					};

					const r = await proxy.$http.postFormData(apiObj.ordloadaudits, params);
					if (r.respCode == 0 || r.respCode == "0000") {
						proxy.$message.success(r.msg || r.respMsg);
						data.isAudit = false;
						getData();
						init(data.lorId, data.index);
					} else {
						proxy.$message.error(r.msg || r.respMsg);
					}
				} else if (data.auditsType == 'unload') {
					let params = {
						lorId: data.lorId,
						lorlId: data.auditsid,
						operate: status, //操作类型：0通过，1不通过
						remark: data.auditsRemark
					};

					const r = await proxy.$http.postFormData(apiObj.ordunloadaudits, params);
					if (r.respCode == 0 || r.respCode == "0000") {
						proxy.$message.success(r.msg || r.respMsg);
						data.isAudit = false;
						getData();
						init(data.lorId, data.index);
					} else {
						proxy.$message.error(r.msg || r.respMsg);
					}
				} else if (data.auditsType == 'expenses') {
					let params = {
						exoId: data.auditsid,
						operate: status, //操作类型：0通过，1不通过
						remark: data.auditsRemark
					};

					const r = await proxy.$http.postFormData(apiObj.expensesOrderExamine, params);
					if (r.respCode == 0 || r.respCode == "0000") {
						proxy.$message.success(r.msg || r.respMsg);
						data.isAudit = false;
						getData();
						init(data.lorId, data.index);
					} else {
						proxy.$message.error(r.msg || r.respMsg);
					}
				}
			};


			const loreeditChange = (item, value) => {
				item.loreedit = value;
				item.loreeditisReadOnly = !value;

			};

			const loadeditChange = (value) => {
				data.loadedit = value;
				data.loadeditisReadOnly = !value;

			};
			const unloadeditChange = (value) => {
				data.unloadedit = value;
				data.unloadeditisReadOnly = !value;

			};
			const planUnloadeditChange = (value) => {
				data.planUnloadedit = value;
				data.planUnloadeditisReadOnly = !value;

			};
			const lorFixededitChange = (value) => {
				data.lorFixededit = value;
				data.lorFixededitisReadOnly = !value;

			};

			const siteLoadChange = (value) => {
				const selectedItem = data.loadsiteList.find(item => item.whId === value);
				if (selectedItem) {
					data.lorLoadAddr = selectedItem.whAddr; // 更新其他参数的值。
					data.lorLoadLnglat = selectedItem.whLnglat;
					data.lorLoadName = selectedItem.whName;
				} else {
					data.lorLoadAddr = null; // 如果没有找到匹配项，则设置为null。
					data.lorLoadLnglat = null;
					data.lorLoadName = null;
				}
			};

			const siteUnloadChange = (index, value) => {
				const selectedItem = data.unloadsiteList.find(item => item.whId === value);
				if (selectedItem) {
					data.unloadList[index].lorlEndAddr = selectedItem.whAddr; // 更新其他参数的值。
					data.unloadList[index].lorlEndLnglat = selectedItem.whLnglat;
					data.unloadList[index].lorlEndName = selectedItem.whName;
					data.unloadList[index].lorlEndContact = selectedItem.whContact;
					data.unloadList[index].lorlEndPhone = selectedItem.whPhone;
					data.unloadList[index].lorlEndContact2 = selectedItem.whContact2;
					data.unloadList[index].lorlEndPhone2 = selectedItem.whPhone2;
				} else {
					data.unloadList[index].lorlEndAddr = null; // 如果没有找到匹配项，则设置为null。
					data.unloadList[index].lorlEndLnglat = null;
					data.unloadList[index].lorlEndName = null;
					data.unloadList[index].lorlEndContact = "";
					data.unloadList[index].lorlEndPhone = "";
					data.unloadList[index].lorlEndContact2 = "";
					data.unloadList[index].lorlEndPhone2 = "";
				}
			};

			const getlorLoadpTime = (ev) => {
				data.lorLoadpTime = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(data.lorLoadpTime);
			};

			const getlorlUnlpTime = (index, ev) => {
				data.unloadList[index].lorlUnlpTime = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(data.unloadList[index].lorlUnlpTime);
			};

			const validateNumber = (value) => {
				// 1. 处理 null/undefined/空值
				if (value === null || value === undefined || value === '') {
					return false;
				}

				// 2. 非数字字符检查
				if (!/^[-+]?\d*\.?\d*$/.test(value)) {
					return false;
				}

				// 3. 小数点位置检查
				if (value.split('.').length > 2) {
					return false;
				}

				// 3. 小数点位置检查
				if (value.indexOf('.') === 0) {
					return false;
				}


				// 4. 负号检查
				if (value.indexOf("-") !== -1) {
					return false;
				}

				// 4. 负号位置检查
				// if (value.startsWith('+') || value.includes('+-') || value.includes('-+')) {
				// 	return false;
				// }

				// 5. 数值范围检查
				const num = Number(value);
				if (isNaN(num)) {
					return false;
				}

				// 处理字符串数字（包括科学计数法）
				return /^[-+]?\d*\.?\d+([eE][-+]?\d+)?$/.test(String(value).trim());
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				dialogClosedHandle,
				getData,
				navClick,
				handleAudits,
				bindloreTypeChange,
				bindloreSubTypeChange,
				Auditssubmit,
				vehicleMUserChange,
				vehicleYUserChange,
				loadeditChange,
				loadeditsave,
				unloadeditChange,
				unloadeditsave,
				planUnloadeditChange,
				planUnloadeditsave,
				lorFixededitsave,
				lorFixededitChange,
				loreeditsave,
				loreeditChange,
				siteLoadChange,
				siteUnloadChange,
				getlorLoadpTime,
				getlorlUnlpTime,
				FreightChk
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 600px;
	}

	.nav_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
		border-bottom: 1px solid #eeeeee;
		display: flex;
		align-items: center;
	}

	.nav_item {
		position: relative;
		height: 78px;
		padding: 0 20px;
		margin-left: 50px;
		cursor: pointer;
	}

	/* 	.nav_item span {
		font-size: 18px;
		color: #666666;
		line-height: 78px;
	} */

	/* .nav_item_ac span {
		color: #293787 !important;
	} */

	.nav_item_line {
		position: absolute;
		width: 90%;
		left: 5%;
		height: 3px;
		background: #293787;
		bottom: 5px;
	}

	.nav_item p {
		font-size: 18px;
		color: #666666;
		line-height: 78px;
		margin: 0 15px;
		position: relative;
	}

	.nav_item_ac p {
		color: #293787 !important;
		/* color: #2eb779; */
		cursor: pointer;
	}

	.nav_item p span {
		display: block;
		width: 20px;
		height: 20px;
		background: #ff0000;
		border-radius: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #fff;
		position: absolute;
		top: 10px;
		right: -10px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.rpt_tit {
		width: 100%;
		height: 70px;
		text-align: left;
		font-weight: bold;
		line-height: 70px;
		font-size: 18px;
		color: #333333;
		text-indent: 42px;
		padding-bottom: 10px;
	}

	.editimg {
		width: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-right: 10px;
		cursor: pointer;
		color: blue;
	}

	.editimg img {
		width: 14px;
		height: 15px;
		margin-right: 8px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 0px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 0px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 30px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 150px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 70%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.auditpass {
		width: 35px;
		height: 16px;
		background: #aaaa00;
		border-radius: 4px;
		text-align: center;
		line-height: 16px;
		font-size: 18px;
		color: #fff;
		padding: 0 5px;
		margin-left: 20px;
	}

	.auditnopass {
		width: 35px;
		height: 16px;
		background: #ff0000;
		border-radius: 4px;
		text-align: center;
		line-height: 16px;
		font-size: 18px;
		color: #fff;
		padding: 0 5px;
		margin-left: 20px;
	}

	.auditwait {
		width: 35px;
		height: 16px;
		background: #0000ff;
		border-radius: 4px;
		text-align: center;
		line-height: 16px;
		font-size: 18px;
		color: #fff;
		padding: 0 5px;
		margin-left: 20px;
	}

	.upRpic_icon_item {
		margin-top: 20px;
		width: 125px;
		height: 60px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}

	.upRpic_icon_item2 {
		margin-top: 0px;
		width: 125px;
		height: 125px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid #eeeeee;
		position: relative;
	}

	.upRpic2_icon {
		width: 125px;
		height: 125px;
		/* width: 100%;
		hieght: auto; */
	}

	.upRpic_icon {
		width: 20px;
		height: 20px;
	}

	.btn-outline1 {
		background: #ff6600 !important;
	}

	.btn-outline2 {
		background: #2eb779 !important;
	}

	.btn_warp {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		align-content: center;
	}

	.btn_warp>div {
		width: 90px;
		height: 36px;
		border-radius: 6px;
		font-size: 14px;
		color: #ffffff;
		cursor: pointer;
		text-align: center;
		line-height: 36px;
		margin-left: 20px;
	}

	.mar-bot-20 {
		margin-bottom: 20px !important;
	}
	
</style>